"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UniPassConnector = exports.UserRejectedRequestError = void 0;
const abstract_connector_1 = require("@web3-react/abstract-connector");
const ethereum_provider_1 = require("@unipasswallet/ethereum-provider");
class UserRejectedRequestError extends Error {
    constructor() {
        super();
        this.name = this.constructor.name;
        this.message = "The user rejected the request.";
    }
}
exports.UserRejectedRequestError = UserRejectedRequestError;
class UniPassConnector extends abstract_connector_1.AbstractConnector {
    constructor(config) {
        super({ supportedChainIds: config.supportedChainIds });
        this.config = config;
        this.handleChainChanged = this.handleChainChanged.bind(this);
        this.handleDisconnect = this.handleDisconnect.bind(this);
    }
    handleChainChanged(chainId) {
        this.emitUpdate({ chainId });
    }
    handleDisconnect() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.unipassProvider) {
                yield this.unipassProvider.disconnect();
                this.unipassProvider.removeListener("chainChanged", this.handleChainChanged);
                this.unipassProvider = undefined;
            }
            this.emitDeactivate();
        });
    }
    activate() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.unipassProvider) {
                this.unipassProvider = new ethereum_provider_1.UniPassProvider(this.config);
            }
            try {
                const account = yield this.unipassProvider.connect();
                this.upAccount = account;
                this.unipassProvider.on("disconnect", this.handleDisconnect);
                this.unipassProvider.on("chainChanged", this.handleChainChanged);
                return { provider: this.unipassProvider, account: account.address };
            }
            catch (_a) {
                throw new UserRejectedRequestError();
            }
        });
    }
    getProvider() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.unipassProvider;
        });
    }
    getChainId() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            return Promise.resolve(((_a = this.unipassProvider) === null || _a === void 0 ? void 0 : _a.getChainId()) || "");
        });
    }
    getAccount() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            return Promise.resolve(((_a = this.upAccount) === null || _a === void 0 ? void 0 : _a.address) || "");
        });
    }
    deactivate() {
        if (this.unipassProvider) {
            this.unipassProvider.removeListener('disconnect', this.handleDisconnect);
            this.unipassProvider.removeListener('chainChanged', this.handleChainChanged);
            this.unipassProvider.disconnect();
        }
    }
}
exports.UniPassConnector = UniPassConnector;
